import { useQuery } from "@tanstack/react-query";
import { Search } from "lucide-react";
import { useState } from "react";
import { useLocation } from "wouter";
import { DataTable } from "@/components/data-table";
import { PageHeader } from "@/components/page-header";
import { StatusBadge } from "@/components/status-badge";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { orpc } from "@/lib/rpc";
import { matchesSearch } from "@/lib/search-utils";

export function ManagerSurveysView() {
  const [searchQuery, setSearchQuery] = useState("");
  const [, setLocation] = useLocation();

  const { data: surveys, isLoading } = useQuery(orpc.pulseSurveys.managerList.queryOptions());

  const filteredSurveys =
    surveys?.filter((survey) => matchesSearch(survey.title, searchQuery)) ?? [];

  const columns = [
    {
      key: "title",
      header: "Pesquisa",
      cell: (survey: any) => <p className="font-medium text-sm">{survey.title}</p>,
    },
    {
      key: "instanceCount",
      header: "Envios",
      cell: (survey: any) => (
        <span className="text-sm text-[hsl(var(--ink-muted))] tabular-nums">
          {survey.instanceCount ?? 0}
        </span>
      ),
    },
    {
      key: "status",
      header: "Status",
      cell: (survey: any) => (
        <StatusBadge
          status={survey.hasActiveInstance ? "has_active_instance" : "no_active_instance"}
        />
      ),
    },
  ];

  return (
    <div className="flex-1 space-y-6">
      <PageHeader
        title="Resultados das Pesquisas"
        description="Acompanhe as respostas dos seus liderados"
      />

      <Card>
        <CardContent className="pt-6 space-y-4">
          <div className="flex items-center gap-4">
            <div className="relative flex-1 max-w-sm">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
              <Input
                placeholder="Buscar pesquisas..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="pl-9"
                data-testid="input-search-surveys-manager"
              />
            </div>
          </div>

          <DataTable
            columns={columns}
            data={filteredSurveys}
            isLoading={isLoading}
            emptyMessage="Nenhuma pesquisa encontrada"
            testIdPrefix="manager-survey"
            onRowClick={(survey) => setLocation(`/surveys/${survey.id}`)}
          />
        </CardContent>
      </Card>
    </div>
  );
}
